module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp1_7005.070a1f1b.png";